import colors from '@/theme/colors';
import { css } from '@emotion/css';

const styles = {
  wrapper: css`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 100%;
  `,
  label: css`
    color: ${colors.charcoal};
  `,
  container: css`
    &.MuiFormControl-root {
      & .MuiInputLabel-root {
        color: ${colors.charcoal};
      }
      & .MuiInput-underline:after {
        border-bottom: 2px solid ${colors.prussian} !important;
      }
    }
  `,
  required: css`
    &.MuiFormControl-root {
      & .MuiInputLabel-root .MuiInputLabel-asterisk {
        color: ${colors.dragon} !important;
      }
    }
  `,
  containerError: css`
    &.MuiFormControl-root {
      &.MuiInput-underline:before,
      &.MuiInput-underline:after {
        border-bottom: 1px solid ${colors.dragon} !important;
      }
    }
  `,
  optionItem: css`
    padding: 6px 16px !important;
    display: grid !important;
    justify-content: flex-start !important;
  `,
  errorMessage: css`
    font-family: 'Montserrat Regular', sans-serif;
    font-size: 0.75rem;
    line-height: 1.33;
    letter-spacing: -0.3px;
    color: ${colors.dragon};
    margin-top: 4px;
  `,
};

export default styles;
